import React from 'react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'
import {useCashbackPositioning} from './useCashbackPositioning'

const LogoWrapper = styled.div`
  min-width: 78px;
`
const LabelWrapper = styled.div`
  flex: 1;
  min-width: 0;
`

export const Wrapper = styled.div<{shouldShowFreeCancellationDate?: boolean}>`
  display: flex;
  align-items: ${({shouldShowFreeCancellationDate}) =>
    shouldShowFreeCancellationDate ? 'start' : 'center'};
  justify-content: space-between;
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400};
  gap: ${cssTheme.layout.spacing.s400};
`

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
`

const RightInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

type Props = Omit<OfferLayoutBaseProps, 'tagComponent'>

export const SecondaryInlineLayout: React.FC<
  Props | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  roomLabelsComponent,
  ctaComponent,
  className,
  dataId,
  cashbackComponent,
  shouldShowFreeCancellationDate = false
}) => {
  const {showCashbackOnLeft, showCashbackOnRight} = useCashbackPositioning({
    cashbackComponent
  })

  if (isLoading)
    return (
      <Wrapper>
        <SkeletonLoader width={139} marginTop={0} />
        <SkeletonLoader width={56} marginTop={0} align="right" />
      </Wrapper>
    )

  return (
    <Wrapper
      className={className}
      data-id={dataId}
      shouldShowFreeCancellationDate={shouldShowFreeCancellationDate}
    >
      <LogoWrapper className="--secondary-inline-layout-logo-wrapper">
        {providerLogoComponent}
      </LogoWrapper>
      <LabelWrapper>
        {roomLabelsComponent}
        {showCashbackOnLeft}
      </LabelWrapper>
      <RightWrapper>
        <RightInnerWrapper>
          {priceComponent}
          {showCashbackOnRight}
        </RightInnerWrapper>
        {ctaComponent}
      </RightWrapper>
    </Wrapper>
  )
}
